module.exports = __webpack_public_path__ + "img/a62ade4dc867325497238bbbe6770712.svg";